import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { SessionEffects } from './session.effects';
import { coreReducers, metaReducers } from './_state.reducers';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthService } from '../services/api/auth.service';
import { NavEffects } from './nav.effects';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        RouterModule,
        StoreModule.forRoot(coreReducers, { metaReducers, runtimeChecks: {
            strictStateSerializability: true,
            strictActionSerializability: true,
            strictStateImmutability: true,
            strictActionImmutability: true
        }}),
        !environment.production ? StoreDevtoolsModule.instrument() : [],
        EffectsModule.forRoot([SessionEffects, NavEffects]),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production
        }),
    ],
    exports: [
    ],
    declarations: [
    ],
    providers: [
        AuthService,
    ]
})
export class CoreModule { }
